import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'redux-first-router-link'
import styles from './AccountHolderSection.module.scss'
import {
  Icon
} from 'belle-js'

const AccountHolderSection = (props) => {
  const { 
    path, 
    section, 
  } = props
  const linkText = 'Update'
  const testId = `accountHolderSection__${section.split(' ').join('')}EditIcon__cta`

  return (
    <div className={styles.AccountHolderSection}>
      <h3>{section}</h3>
      <div className={styles.section}>
        <NavLink to={path} className={styles.sectionStatus} data-test-id={testId} >
          <div className={styles.sectionActionText}>{linkText}</div>
          <Icon iconClasses={styles.edit} icon="edit_15" width={12} height={12} />
        </NavLink>
      </div>
    </div>
  )
}

AccountHolderSection.propTypes = {
  isComplete: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired
}

export default AccountHolderSection



// WEBPACK FOOTER //
// ./src/components/Onboarding/ReviewAndSubmit/AccountHolderSection/AccountHolderSection.jsx